import { api } from './client';

export type AppConfig = {
  /** Venmo username (no @). Null when not configured. */
  venmoHandle: string | null;
  /** PayPal.me handle. Null when not configured. */
  paypalHandle: string | null;
  /** System-wide default machine label. Always populated. */
  machineName: string;
};

export const configApi = {
  get: () => api.get<AppConfig>('/api/config'),
};
